import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=34c9c20a&scoped=true"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"
import style0 from "./MatchCard.vue?vue&type=style&index=0&id=34c9c20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c9c20a",
  null
  
)

export default component.exports